import { defineComponent } from 'vue'
import styles from './styles.module.scss'

/**
 * 首页信息功能模块
 */
export default defineComponent({
  name: 'information-mobile-legend-view',
  setup: () => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    // const lang = new URLSearchParams(window.location.search).get('lang')
    // const isEn = componentsConfig?.lang?.show || lang == 'en'
    const showEachLegend = (key: string) => {
      return componentsConfig?.filter?.properties?.items?.indexOf(key) > -1
    }
    return () => (
      <div class={styles.mark}>
        {(showEachLegend('recharge') || showEachLegend('recharge|ps')) && (
          <div>
            <i class={[styles.imgArea, styles.swap]}></i>
            <div>蔚来能源换电站</div>
          </div>
        )}
        {componentsConfig.route_render?.show && (
          <>
            <div>
              <i class={[styles.imgArea, styles.swap]}></i>
              <div class={styles.lineSwap}></div>
              <div>高速换电网络</div>
            </div>
            {/* <div>
              <i class={[styles.imgArea, styles.station]}></i>
              <div class={styles.linePower}></div>
              <div>{isEn ? 'Power Journeys' : 'Power Journeys 加电风景线'}</div>
            </div> */}
          </>
        )}
        {(showEachLegend('recharge') || showEachLegend('recharge|cs')) && (
          <>
            <div>
              <i class={[styles.imgArea, styles.station]}></i>
              <div>蔚来能源充电站</div>
            </div>
            {componentsConfig.third_resource?.show ? (
              <div>
                <i class={[styles.imgArea, styles.third]}></i>
                <div>第三方充电桩</div>
              </div>
            ) : null}
          </>
        )}
        {componentsConfig.route_render?.show && (
          <>
            {/* <div>
              <i class={[styles.imgArea, styles.swap]}></i>
              <div class={styles.lineSwap}></div>
              <div>{isEn ? 'Expressway Power Swap Network' : '高速换电网络'}</div>
            </div> */}
            <div>
              <i class={[styles.imgArea, styles.station]}></i>
              <div class={styles.linePower}></div>
              <div>Power Journeys 加电风景线</div>
            </div>
          </>
        )}
      </div>
    )
  },
})
